<template>
  <div class="create-head-hunter">
    <div class="create-head-hunter__section-title">Аккаунт на HeadHunter</div>
    <div class="flex gap-4">
     <div class=" w-full">
       <VAutocomplete class=" w-full"
                      placeholder="Выберите аккаунт на HeadHunter*"
                      v-model="form.hh_integration"
                      :items="integrationOptionsItems"
                      item-value="id"
                      item-text="label"
                      :error="v$.hh_integration.$error"
       />
       <p class="create-head-hunter__inp-error"
          v-if="v$.hh_integration.$error">
         Заполните обязательное поле</p>
     </div>

      <div class=" w-full">
        <VAutocomplete class=" w-full"
                       placeholder="Выберите менеджера для вакансии*"
                       v-model="form.hh_manager"
                       :items="hh_managerOptionsItems"
                       :disabled="!form.hh_integration"
                       item-value="id"
                       item-text="label"
                       :error="v$.hh_manager.$error"
        />
        <p class="create-head-hunter__inp-error"
           v-if="v$.hh_manager.$error">
          Заполните обязательное поле</p>
      </div>
    </div>

    <div class="create-head-hunter__section-title">Основная информация</div>

    <div class="flex gap-4">
      <div class="w-full ">
        <VCustomInput placeholder="Название вакансии*"
                      v-model="form.title"
                      :error="v$.title.$error"
                      class="w-full"/>
        <p class="create-head-hunter__inp-error"
           v-if="v$.title.$error">
          Заполните обязательное поле</p>
      </div>
      <div class="w-full ">
        <VAutocomplete class=" w-full"
                       placeholder="Специализация*"
                       v-model="form.professional_roles"
                       :items="professional_rolesOptionsItems"
                       :disabled="!form.hh_integration"
                       item-value="id"
                       item-text="label"
                       :error="v$.professional_roles.$error"
                       @input="(el) => professional_rolesChange = el"
        />
        <p class="create-head-hunter__inp-error"
           v-if="v$.professional_roles.$error">
          Заполните обязательное поле</p>
      </div>
    </div>

    <div class="wrapper">
      <VTagsInputMultiSelect
          class="w-full"
          placeholder="Где искать сотрудника (город)*"
          :options="areasOptionsItems"
          :isWithoutCheckmarks="true"
          v-model="form.areas"
          item-value="id"
          item-text="label"
          :disabled="!form.hh_integration"
          :error="v$.areas.$error"
          @input="(el) => areasChange = el"
      />
      <p class="create-head-hunter__inp-error"
         v-if="v$.areas.$error">
        Заполните обязательное поле</p>
    </div>
    <div class="create-head-hunter__section-description">Каждый указанный город означает одну публикацию вакансии</div>
<!--    <div class="flex gap-4">-->

<!--      <VCustomInput placeholder="Предполагаемый доход от"-->
<!--                    type="number"-->
<!--                    v-model="form.estimated_from"-->
<!--                    class="w-full "/>-->

<!--      <VCustomInput placeholder="Предполагаемый доход до"-->
<!--                    v-model="form.estimated_to"-->
<!--                    class="w-full"/>-->

<!--      <VSelect placeholder="Валюта"-->
<!--               :options="currencyOption"-->
<!--                    v-model="form.сurrency"-->
<!--                    class="w-full "/>-->
<!--    </div>-->

<!--    <VCheckboxNew style="margin-top: 12px"  v-model="form.before_taxes"  label="До вычета налогов" />-->

<!--    <div class="wrapper">-->
<!--      <VSearchSelectCity-->
<!--          class="w-full"-->
<!--          placeholder="Где будет работать сотрудник"-->
<!--          v-model="form.job_city"-->
<!--      />-->
<!--    </div>-->
<!--    <div class="create-head-hunter__section-description">Если предполагается разъездная работа укажите адрес основного офиса</div>-->

<!--    <VCheckboxNew style="margin-top: 12px"  v-model="form.only_metro"  label="Показывать кандидатам только станцию метро" />-->

    <div class="wrapper">
      <VAutocomplete class=" w-full"
                     placeholder="Опыт работы*"
                     v-model="form.experience"
                     :items="experienceOptionsItems"
                     :disabled="!form.hh_integration"
                     item-value="id"
                     item-text="label"
                     :error="v$.experience.$error"
                     @input="(el) => experienceChange = el"
      />
      <p class="create-head-hunter__inp-error"
         v-if="v$.experience.$error">
        Заполните обязательное поле</p>
    </div>


    <div class="wrapper">
      <VTagsInputMultiSelect
          class="w-full"
          placeholder="Ключевые навыки"
          :options="key_skillsOptionsItems"
          :isWithoutCheckmarks="true"
          v-model="form.key_skills"
          item-value="id"
          item-text="label"
          :disabled="!form.hh_integration"
          @input="(el) => key_skillsChange = el"
      />
    </div>

<!--    <div class="wrapper">-->
<!--      <VAutocomplete class="w-full"-->
<!--                     placeholder="Ключевые навыки*"-->
<!--                     v-model="form.key_skills"-->
<!--                     :items="key_skillsOptionsItems"-->
<!--                     :disabled="!form.hh_integration"-->
<!--                     :error="v$.key_skills.$error"-->
<!--                     multiselect-->
<!--                     item-text="label"-->
<!--                     item-value="id"-->
<!--                     @input="(el) => key_skillsChange = el"-->
<!--      />-->
<!--      <p class="create-head-hunter__inp-error"-->
<!--         v-if="v$.key_skills.$error">-->
<!--        Заполните обязательное поле</p>-->
<!--    </div>-->

    <div class="create-head-hunter__section-title">Расскажите о вакансии*</div>
    <div class="create-head-hunter__section-description">Не менее 200 символов. Не пишите контактных данных в описании</div>


    <div class="basic-information__section-form">
      <VEditor placeholder="Расскажите о вакансии*"  v-model="form.description"
               id="description"
               :error="v$.description.$error"
               class="basic-information__editor"/>
      <p class="create-head-hunter__inp-error"
         v-if="v$.description.$error">
        Заполните обязательное поле</p>
    </div>


    <div class="create-head-hunter__section-title">Контактные данные</div>
    <div class="wrapper">
      <VCustomInput placeholder="Контактное лицо*"
                    v-model="form.contacts.full_name"
                    :error="v$.contacts.full_name.$error"
                    class="w-full "/>
      <p class="create-head-hunter__inp-error"
         v-if="v$.contacts.full_name.$error">
        Заполните обязательное поле</p>
    </div>

    <div style="margin-bottom: 16px" class="wrapper">
      <VCustomInput placeholder="E-mail*"
                    v-model="form.contacts.email"
                    :error="v$.contacts.email.$error"
                    class="w-full "/>
      <p class="create-head-hunter__inp-error"
         v-if="v$.contacts.email.$error">
        Заполните обязательное поле</p>
    </div>

    <div class="wrapper">
      <VCustomInput placeholder="Телефон*"
                    v-mask="'+0(000) 000-00-00'"
                    v-model="form.contacts.phone"
                    :error="v$.contacts.phone.$error"
                    class="w-full "/>
      <p class="create-head-hunter__inp-error"
         v-if="v$.contacts.phone.$error">
        Заполните обязательное поле</p>
<!--      <VCustomInput placeholder="Дополнительный телефон"-->
<!--                    v-model="form.sub_phone"-->
<!--                    class="w-full "/>-->
    </div>

<!--    <div class="wrapper">-->
<!--      <VCustomInput placeholder="Комментарий"-->
<!--                    v-model="form.comment"-->
<!--                    class="w-full "/>-->
<!--    </div>-->



    <div class="create-head-hunter__section-title">Дополнительно</div>
    <div class="flex flex-col gap-4">
      <div class="flex gap-4">
        <div class="w-full">
          <VAutocomplete placeholder="Тип занятости*"
                         v-model="form.employment_form"
                         :items="employment_formOptionsItems"
                         :disabled="!form.hh_integration"
                         :error="v$.employment_form.$error"
                         item-value="id"
                         item-text="label"
          />
          <p class="create-head-hunter__inp-error"
             v-if="v$.employment_form.$error">
            Заполните обязательное поле</p>
        </div>
        <div class="w-full">
          <VAutocomplete placeholder="График работы*"
                         v-model="form.work_schedule_by_days"
                         :items="work_schedule_by_daysOptionsItems"
                         :disabled="!form.hh_integration"
                         :error="v$.work_schedule_by_days.$error"
                         item-value="id"
                         item-text="label"
          />
          <p class="create-head-hunter__inp-error"
             v-if="v$.work_schedule_by_days.$error">
            Заполните обязательное поле</p>
        </div>
      </div>

<!--      <div class="flex gap-4">-->
<!--        <VSelect placeholder="Категория прав"-->
<!--                 :options="currencyOption"-->
<!--                 v-model="form.category_of_rights"-->
<!--                 class="w-full "/>-->
<!--        <VSelect placeholder="Брендированный шаблон вакансии"-->
<!--                 :options="currencyOption"-->
<!--                 v-model="form.brand_template"-->
<!--                 class="w-full "/>-->
<!--      </div>-->

      <div>
        <VAutocomplete class=" w-full"
                       placeholder="Тип размещения*"
                       v-model="form.publication_variant"
                       :items="publication_variantOptionsItems"
                       :disabled="!form.hh_integration"
                       item-value="id"
                       item-text="label"
                       :error="v$.publication_variant.$error"
        />
        <p class="create-head-hunter__inp-error"
           v-if="v$.publication_variant.$error">
          Заполните обязательное поле</p>
<!--        <VSelect placeholder="Тип вакансии*"-->
<!--                 :options="currencyOption"-->
<!--                 v-model="form.job_type"-->
<!--                 class="w-full "/>-->
      </div>
    </div>

<!--    <div class="create-head-hunter__section-title">Кто может откликаться</div>-->

<!--    <div class="flex flex-col gap-4">-->
<!--      <div class="flex gap-4">-->
<!--        <VCheckboxNew class="w-full" style="margin-top: 12px"  v-model="form.applicants_with_disabilities"  label="Соискатели с инвалидностью" />-->
<!--        <VCheckboxNew class="w-full" style="margin-top: 12px"  v-model="form.temporary_registration_is_possible"  label="Возможно временное оформление" />-->
<!--      </div>-->
<!--      <div class="flex gap-4">-->
<!--        <VCheckboxNew class="w-full" style="margin-top: 12px"  v-model="form.applicants_with_incomplete_resumes"  label="Соискатели с неполным резюме" />-->
<!--        <VCheckboxNew class="w-full" style="margin-top: 12px"  v-model="form.with_cover_letter_only"  label="Только с сопроводительным письмом" />-->
<!--      </div>-->
<!--      <div class="flex gap-4">-->
<!--        <VCheckboxNew class="w-full" style="margin-top: 12px"  v-model="form.applicants_from_14_years_old"  label="Соискатели от 14 лет" />-->
<!--      </div>-->
<!--    </div>-->

    <div class="create-head-hunter__section-title">Ответственный менеджер</div>
    <div class="create-head-hunter__section-description">Выберите менеджера, который будет работать с откликами</div>
    <VManagerField
        class=" w-full"
        placeholder="Выберите ответственного менеджера*"
        v-model="form.hr"
        :error="v$.hr.$error"
    />
    <div style="margin-top: 24px" class="flex gap-6">
      <VButtonNew class="w-full" style-type="grey" label="Отменить" @click="emit('cancel')"/>
      <VButtonNew class="w-full" label="Создать вакансию" @click="apply"/>
    </div>
  </div>
</template>
<script setup>
import VIntegrationField from "@/components/UI/DataFields/VIntegrationField/index.vue";
import {computed, onMounted, ref, watch} from "vue";
import VManagerField from "@/components/UI/DataFields/VManagerField/index.vue";
import VSearchSelectCity from "@/components/UI/VSearchSelect/City.vue";
import VSelect from "@/components/UI/VSelect/index.vue";
import VButtonNew from "@/components/UI/VButtonNew/index.vue";
import externalIntegrations from "@/api/externalIntegrations";
import VAutocomplete from "@/components/UI/VAutocomplete/index.vue";
import useVuelidate from "@vuelidate/core";
import eventBus from "@/services/eventBus";

const props = defineProps({
  vacancyId: {
    type: [String, Number],
  }
});
const emit = defineEmits(["cancel"]);

const form = ref({
  hh_integration: "",
  hh_manager: "",
  title: "",
  professional_roles: "",
  areas: "",
  // job_city: "",
  // estimated_from: "",
  // estimated_to: "",
  // сurrency: "",
  // before_taxes: false,
  // only_metro: false,
  experience: "",
  key_skills: "",
  description: "",
  contacts: {
    full_name: null,
    email: null,
    phone: null,
  },
  // sub_phone: "",
  // comment: "",
  employment_form: "",
  work_schedule_by_days: "",
  // category_of_rights: "",
  // brand_template: "",
  publication_variant: "",
  // job_type: "",
  // applicants_with_disabilities: false,
  // temporary_registration_is_possible: false,
  // applicants_with_incomplete_resumes: false,
  // with_cover_letter_only: false,
  // applicants_from_14_years_old: false,
  hr: "",
})

const requiredField = (val) => {
  console.log(val)
  return !!val
}

const areasValid = () => {
  return form.value.areas?.length > 0
}

const rules = computed(() => ({
  hh_integration: {requiredField},
  hh_manager: {requiredField},
  title: {requiredField},
  professional_roles: {requiredField},
  areas: {areasValid},
  experience: {requiredField},
  description: {requiredField},
  publication_variant: {requiredField},
  hr: {requiredField},
  contacts: {
    phone: {requiredField},
    full_name: {requiredField},
    email: {requiredField},
  },
  employment_form: {requiredField},
  work_schedule_by_days: {requiredField},
  key_skills: {requiredField},
}))

const v$ = useVuelidate(rules, form);

const currencyOption = [
  {id: 'rub', label: 'Рубли'},
  {id: 'usd', label: 'Доллары США'},
  {id: 'euro', label: 'Евро'}
]

const integrationOptions = ref([])
const integrationOptionsItems = computed(() => {
  if (integrationOptions.value?.integrations?.length < 1) {
    return []
  } else {
    return integrationOptions.value?.integrations?.map(e => {
      return {
        label: e.name,
        id: e.id,
      }
    })
  }
})

const experienceChange = ref('')
const dictOptions = ref([])
const experienceOptionsItems = computed(() => {
  if (dictOptions.value?.experience?.length < 1) {
    return []
  } else {
    return dictOptions.value?.experience?.map(e => {
      return {
        label: e.name,
        id: e.id,
      }
    })
  }
})

const employment_formOptionsItems = computed(() => {
  if (dictOptions.value?.employment_form?.length < 1) {
    return []
  } else {
    return dictOptions.value?.employment_form?.map(e => {
      return {
        label: e.name,
        id: e.id,
      }
    })
  }
})
const work_schedule_by_daysOptionsItems = computed(() => {
  if (dictOptions.value?.work_schedule_by_days?.length < 1) {
    return []
  } else {
    return dictOptions.value?.work_schedule_by_days?.map(e => {
      return {
        label: e.name,
        id: e.id,
      }
    })
  }
})

const publication_variantOptions = ref([])
const publication_variantOptionsItems = computed(() => {
  if (publication_variantOptions.value?.length < 1) {
    return []
  } else {
    return publication_variantOptions.value?.items?.map(e => {
      return {
        label: e.title,
        id: e.id,
      }
    })
  }
})

const hh_managerOptions = ref([])


const hh_managerOptionsItems = computed(() => {
  if (hh_managerOptions.value?.length < 1) {
    return []
  } else {
    return hh_managerOptions.value?.items?.map(e => {
      return {
        label: e.full_name,
        id: e.id,
      }
    })
  }
})
watch(() => form.value.hh_integration, async () => {
  form.value.hh_manager = ''
  if(form.value.hh_integration) {
    dictOptions.value =
        await externalIntegrations.getHeadHunterOptions(form.value.hh_integration, 'dictionaries', '')
    publication_variantOptions.value = await externalIntegrations.getHeadHunterOptions(form.value.hh_integration, 'publication-variants')
    hh_managerOptions.value =  await externalIntegrations.getHeadHunterOptions(form.value.hh_integration, 'managers', '')
  }
})

const professional_rolesChange = ref('')
const professional_rolesOptions = ref([])
const professional_rolesOptionsItems = computed(() => {
  if (professional_rolesOptions.value?.length < 1) {
    return []
  } else {
    return professional_rolesOptions.value?.items?.map(e => {
      return {
        label: e.text,
        id: e.id,
      }
    })
  }
})
watch(() => professional_rolesChange.value, async () => {
  if(professional_rolesChange.value?.length > 1) {
    professional_rolesOptions.value =
        await externalIntegrations.getHeadHunterOptions(form.value.hh_integration, 'professional-roles', professional_rolesChange.value?.toLowerCase())  }
})


const areasChange = ref('')
const areasOptions = ref([])
const areasOptionsItems = computed(() => {
  if (areasOptions.value?.length < 1) {
    return []
  } else {
    return areasOptions.value?.items?.map(e => {
      return {
        label: e.text,
        id: e.id,
      }
    })
  }
})
watch(() => areasChange.value, async () => {
  if(areasChange.value?.length > 1) {
    areasOptions.value =
        await externalIntegrations.getHeadHunterOptions(form.value.hh_integration, 'areas', areasChange.value?.toLowerCase())  }
})
const key_skillsChange = ref('')
const key_skills = ref([])
const key_skillsOptions = ref([])
const key_skillsOptionsItems = computed(() => {
  if (key_skillsOptions.value?.length < 1) {
    return []
  } else {
    return key_skillsOptions.value?.items?.map(e => {
      return {
        label: e.text,
        id: e.id,
      }
    })
  }
})
watch(() => key_skillsChange.value, async () => {
  if(key_skillsChange.value?.length > 1) {
    key_skillsOptions.value =
        await externalIntegrations.getHeadHunterOptions(form.value.hh_integration, 'skills', key_skillsChange.value?.toLowerCase())  }
})


const apply = async () => {
  const validate = await v$.value.$validate();
  if (!validate) {
    return
  }

  let args = {
    hh_integration: form.value.hh_integration,
    hh_manager: form.value.hh_manager,
    title: form.value.title,
    professional_roles: [form.value.professional_roles],
    areas: form.value.areas,
    experience: form.value.experience,
    description: form.value.description,
    publication_variant: form.value.publication_variant,
    hr: form.value.hr,
  }

  if(form.value.employment_form) {
    args.employment_form = form.value.employment_form
  }

  if(form.value.work_schedule_by_days) {
    args.work_schedule_by_days = form.value.work_schedule_by_days
  }

  if(form.value.key_skills) {
    args.key_skills = form.value.key_skills
  }

  if(form.value.contacts.full_name && form.value.contacts.email && form.value.contacts.phone) {
    args.contacts = {}
    if(form.value.contacts.full_name) {
      args.contacts.full_name = form.value.contacts.full_name
    }
    if(form.value.contacts.email) {
      args.contacts.email = form.value.contacts.email
    }
    if(form.value.contacts.phone) {
      args.contacts.phone = form.value.contacts.phone
    }
  }

  try {
    await externalIntegrations.publishHeadHunter(props.vacancyId, args)
    emit('cancel')
  } catch (e) {
    console.log(e.response?.data?.errors, 'error')
    if(e?.response?.data?.errors[0]?.not_enough_purchased_services) {
      eventBus.emit("errorRequest", {
        title: "Не хватает вакансий для публикации",
        description: "Чтобы создать вакансию, пополните баланс вакансий на платформе HeadHunter",
        eventText: "Повторить",
        eventClick: apply,
      });
    } else {
      eventBus.emit("errorRequest", {
        title: "Ошибка",
        description: "Произошла ошибка. Пожалуйста, попробуйте позже",
        eventText: "Повторить",
        eventClick: apply,
      });
    }

  }
  // emit('cancel')
}

onMounted(async () => {
  integrationOptions.value = await externalIntegrations.getHeadHunter()
})



</script>
<style scoped lang="scss">
.create-head-hunter {
  &__section-title {
    margin-top: 24px;
    margin-bottom: 12px;
    color: $dark;
    font-weight: 500;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0;
  }

  &__section-description {
    color: $gray;
    font-size: 14px;
    font-weight: 400;
    line-height: 100%;
    letter-spacing: 0;
    margin-bottom: 16px;
  }

  &__inp-error {
    margin-top: 4px;
    font-size: 14px;
    color: $red;
  }
}
.wrapper {
  margin-top: 16px;
  margin-bottom: 4px;
}
</style>